import { User, Mail, Phone, Eye, Edit } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Contact } from "./types";
import { useTranslation } from "react-i18next";

interface ContactListItemProps {
  contact: Contact;
  onView: (contact: Contact) => void;
  onEdit: (contact: Contact) => void;
}

export const ContactListItem = ({ contact, onView, onEdit }: ContactListItemProps) => {
  const { t } = useTranslation();
  const fullName = `${contact.first_name} ${contact.last_name || ''}`.trim();
  
  return (
    <div className="border rounded-sm p-4">
      <div className="flex justify-between items-center">
        <div className="flex items-center">
          <User className="h-5 w-5 text-gray-400 mr-3" />
          <div>
            <h4 className="font-medium">{fullName}</h4>
            <div className="flex items-center gap-4 text-sm text-gray-600">
              {contact.function && <span>{contact.function}</span>}
              {contact.email && (
                <a href={`mailto:${contact.email}`} className="flex items-center text-digger-blue hover:underline">
                  <Mail className="h-3 w-3 mr-1" />
                  {contact.email}
                </a>
              )}
              {contact.phone && (
                <a href={`tel:${contact.phone}`} className="flex items-center text-digger-blue hover:underline">
                  <Phone className="h-3 w-3 mr-1" />
                  {contact.phone}
                </a>
              )}
            </div>
          </div>
        </div>
        
        <div className="flex space-x-2">
          <Button 
            variant="outline" 
            size="sm"
            onClick={() => onView(contact)}
          >
            <Eye className="h-4 w-4 mr-1" />
            {t("contacts.view")}
          </Button>
          <Button 
            variant="outline" 
            size="sm"
            onClick={() => onEdit(contact)}
          >
            <Edit className="h-4 w-4 mr-1" />
            {t("contacts.edit")}
          </Button>
        </div>
      </div>
    </div>
  );
};
